/*
  NUDIENT: Ankaret i adressen från 990, M-167. Utredning:
  nudient/BESLUT.md M-167.

  Från 990 är Horizons .page-wrapper sidans skrollbara del, och <html> har
  overflow: hidden, assets/base.css rad 27 till 33 och 47 till 55 och
  assets/scroll-container.js. Laddas en sida med ett ankare i adressen, till
  exempel efter en anmälan till nyhetsbrevet, /?customer_posted=true
  #NudientFooterNewsletter, skrollar webbläsaren både .page-wrapper till
  ankaret och <html>. <html> kan kunden inte skrolla tillbaka, så sidans övre
  del ligger kvar utanför bild och resten ser vit ut.

  Skriptet nollställer <html> och <body> och lägger ankaret mitt i
  .page-wrapper, så att tackmeddelandet syns vid formuläret. Det körs när
  sidan har laddats, vid hashchange, och bara från 990. Under 990 skrollar
  <html> som vanligt och skriptet gör ingenting.

  "Gå vidare till innehåll", M-167 tillägget: Horizons länk
  .skip-to-content-link hoppar till #MainContent men flyttar inte fokus,
  eftersom <main> inte kan få fokus. Skriptet ger målet tabindex="-1" och
  flyttar fokus dit efter hoppet, så att nästa Tab går vidare därifrån och
  skärmläsare börjar läsa där. Gäller i alla bredder. Marginalen under
  sidhuvudet står i assets/nudient-header.css.

  Värden som inte är tokens:
  - (min-width: 990px): Horizons gräns för .page-wrapper som skrollbar del,
    samma som assets/scroll-container.js, inte en av Nudients brytpunkter.
  - instant: skrollningen utan Horizons scroll-behavior: smooth.
  - 2: ankaret mitt i fönstret.
  - -1 i tabindex: målet kan få fokus av skriptet men hamnar inte i
    tabbordningen.
*/

const SQUEEZE = window.matchMedia('(min-width: 990px)');

function fixAnchorScroll() {
  if (!SQUEEZE.matches) return;
  const root = document.documentElement;
  if (root.scrollTop === 0 && document.body.scrollTop === 0) return;
  const wrapper = document.querySelector('.page-wrapper');
  let target = null;
  try {
    target = location.hash ? document.getElementById(decodeURIComponent(location.hash.slice(1))) : null;
  } catch {}
  /* .page-wrapper skrollas direkt, eftersom scrollIntoView också skrollar <html> */
  if (wrapper && target) {
    const box = target.getBoundingClientRect();
    const top = wrapper.scrollTop + box.top - (window.innerHeight - box.height) / 2;
    wrapper.scrollTo({ top: Math.max(0, top), behavior: 'instant' });
  }
  root.scrollTop = 0;
  document.body.scrollTop = 0;
}

if (document.readyState === 'complete') fixAnchorScroll();
else window.addEventListener('load', fixAnchorScroll, { once: true });
window.addEventListener('hashchange', fixAnchorScroll);

/* Gå vidare till innehåll: fokus till målet efter hoppet, M-167 tillägget */
document.addEventListener('click', (event) => {
  const link = event.target instanceof Element ? event.target.closest('a.skip-to-content-link') : null;
  if (!(link instanceof HTMLAnchorElement)) return;
  let target = null;
  try {
    target = document.getElementById(decodeURIComponent(new URL(link.href).hash.slice(1)));
  } catch {}
  if (!target) return;
  if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
  requestAnimationFrame(() => target.focus({ preventScroll: true }));
});
